import $ from 'jquery';
import Breakpoints from '@shopify/marketing-assets/javascripts/global/breakpoints';
import Fn from '@shopify/marketing-assets/javascripts/helpers/utils';
import A11yHelpers from '@shopify/marketing-assets/javascripts/global/a11y-helpers';

class Sheet {
  Breakpoints = new Breakpoints();
  isSheetBodySet = false;

  CLASSES = {
    sheetIsOpen: 'js-ui-sheet-open',
  };

  GLOBAL_NODES = {
    $window: $(window),
    $body: $('body'),
    $activator: $('.js-ui-sheet-activator'),
    $deactivator: $('.js-ui-sheet-deactivator'),
  };

  moveContent = Fn.debounce(() => {
    if (window.matchMedia(this.breakpoint).matches) {
      if (this.isSheetBodySet) {
        return;
      }

      $.each(this.options.$contentNodes, (index, $contentNode) => {
        const $placeholder = $(`<div class='placeholder-${index}'></div>`);
        $contentNode.parent().append($placeholder);
        $contentNode.appendTo(this.nodes.$sheetBody);
      });

      this.isSheetBodySet = true;
    } else if (!this.options.allowDesktopView) {
      $.each(this.options.$contentNodes, (index, $contentNode) => {
        const $placeholder = $(`.placeholder-${index}`);
        $contentNode.insertAfter($placeholder);
        $placeholder.remove();
      });
      this.isSheetBodySet = false;
      this.closeSheet();
    }
  }, 100);

  constructor($sheet, options) {
    if (!($sheet.length && $sheet instanceof $)) {
      return;
    }

    this.options = options;

    this.nodes = {
      $sheet,
      $sheetBody: $sheet.find('.js-ui-sheet-body'),
    };

    this.breakpoint = this.options.tabletDown ? this.Breakpoints.tabletDown : this.Breakpoints.phone;

    this.GLOBAL_NODES.$window.on('resize', this.moveContent);
    this.GLOBAL_NODES.$activator
      .on('click', this.openSheet)
      .on('click', this.moveContent);
    this.GLOBAL_NODES.$deactivator.on('click', this.closeSheet);
  }

  openSheet = () => {
    this.GLOBAL_NODES.$body.addClass(this.CLASSES.sheetIsOpen);
    A11yHelpers.prototype.trapFocus(this.nodes.$sheet);
  };

  closeSheet = () => {
    this.GLOBAL_NODES.$body.removeClass(this.CLASSES.sheetIsOpen);
    A11yHelpers.prototype.removeTrapFocus(this.nodes.$sheet);
    this.GLOBAL_NODES.$activator.focus();
  };
}

export default Sheet;
